import { commonGetData, commonPostData } from "./common";

// wrapper: le chiamate alle nostre /api viaggiano con il token (withCredential=true)
export async function getData(
    url = "",
    data: Record<string, unknown> = {},
    withCredential = true,
) {
    return await commonGetData(withCredential, {}, url, data);
}

export async function postData(
    url = "",
    data: unknown = {},
    withCredential = true,
) {
    return await commonPostData(withCredential, {}, url, data);
}
